// extracted by mini-css-extract-plugin
export default {"container":"LevelsPage_container__aPQ1Z","grid":"LevelsPage_grid__pirIp"};